import {
  Component,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { SubjectService } from 'app/shared/services/subject.service';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { CountWidgetSettings } from 'app/shared/models/count-widget-settings';
import { UserService } from 'app/shared/services/user.service';
import { LabelService } from '../../label.service';
import { SubjectType } from 'app/shared/models/subject-type';
import { Subscription } from 'rxjs';
import { SubjectTypeService } from 'app/shared/services/subject-type.service';
import { SubjectSettingService } from 'app/shared/services/subject-setting.service';
import { Utilities } from 'app/shared/helpers/utilities';
import { OrganisationService } from 'app/shared/services/organisation.service';
import { Organisation } from 'app/shared/models/organisations';
import { environment } from 'environments/environment';
import { AuthService } from 'app/shared/services/auth.service';

@Component({
  selector: 'subject-review-count-widget-settings',
  templateUrl: './subject-review-count-widget-settings.component.html',
  styleUrls: ['./subject-review-count-widget-settings.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SubjectReviewCountWidgetSettingsComponent
  implements OnInit, OnDestroy {
  types: SubjectType[] = [];
  form: UntypedFormGroup;
  settings: CountWidgetSettings;
  color: string;
  originalColor: string;
  prev: number[];
  users: number[] = [];
  //DRJ- I use the below sTypes rather than using the services to get all the Subject Types
  //as for this instance we want only Cases or Referrals to be available.
  onOrganisationsChanged: Subscription;
  organisations: Organisation[] = [];
  organisationLabel = 'Organisation';
  hasOrganisation = false;
  showOrganisations = false;
  organisaitonReadonly: boolean = false;

  sTypes = [
    { id: 1, name: 'Case' },
    { id: 2, name: 'Referral' },
  ];
  filters = [
    { id: 1, name: 'Reviews due today' },
    { id: 7, name: 'Reviews due within the next 7 days' },
    { id: 30, name: 'Reviews due within the next 30 days' },
    { id: 9999, name: 'All reviews' },
  ];

  prevContextValue: any;

  dlgTitle = 'Subjects Due Review Count Widget Settings';

  labelMaxLength = this.labelService.MAXLENGTH;
  titleMaxLength = 55;

  onTypesChanged: Subscription;
  activeUsers: Subscription;
  contextGeneral = this.labelService.CONTEXTS;
  contextUsers: any[] = [];
  contexts = this.labelService.CONTEXTS;

  labelChanged = false;
  titleChanged = false;
  //filterChanged = false;
  constructor(
    public dialogRef: MatDialogRef<SubjectReviewCountWidgetSettingsComponent>,
    public labelService: LabelService,
    public subjectService: SubjectService,
    public subjectTypeService: SubjectTypeService,
    public subjectSettingService: SubjectSettingService,
    public userService: UserService,
    private authService: AuthService,
    private organisationService: OrganisationService,
    @Inject(MAT_DIALOG_DATA) public data: CountWidgetSettings,
    private fb: UntypedFormBuilder
  ) {
    // console.log(data)        
    this.settings = data || new CountWidgetSettings();
    if (this.userService.getCurrentUser().organisationId && this.settings.organisationId == undefined)
      this.settings.organisationId = this.userService.getCurrentUser().organisationId;
    console.log(this.settings);
    this.settings.caseOrReferralDueReview = true;
    this.settings.color = this.settings.color || '#f44336'; // 'rgb(244, 67, 54)';
    this.settings.showExtra == false;         
  }

  ngOnInit(): void {
    this.activeUsers = this.userService.getActiveUsers().subscribe((users) => {
      const meId = this.userService.getCurrentUserId();
      const hasAdminPriv = this.authService.hasPriv('admin');
      this.contextUsers = [];
      users.forEach((i) => {
        if (
          (!environment.limitAccessToSubjectsByOrg && hasAdminPriv) ||
          i.id === meId ||
          i.managerId === meId
        ) {
          this.contextUsers.push({ id: i.id, name: i.id === meId ? 'Me' : i.fullName });
        }
      });
      this.contextUsers
        .sort((a, b) => a.name.localeCompare(b.name))
        .forEach((i) => {
          this.contexts.push(i);
        });
    });

    if (!this.settings.label || this.settings.label === '') {
      const label = this.labelService
        .getDefaultCountLabel(this.settings)
        .toUpperCase();
      // this.labelChanged = !!(label && label !== this.settings.label);
    }

    if (!this.settings.title || this.settings.title === '') {
      const title = this.labelService
        .getReviewTitle(this.settings)
        .toUpperCase();
      // this.titleChanged = !!(title && title !== this.settings.title);
    }

    if (!this.settings.filterId) {
      const title = this.labelService
        .getReviewTitle(this.settings)
        .toUpperCase();
    }

    this.prevContextValue = this.settings.context;
    if (this.settings.context) {
      this.prevContextValue = this.labelService.getContext(
        this.settings.context
      );
    }

    this.onOrganisationsChanged = this.organisationService.onChanged.subscribe((response) => {
      if (response.length > 0) {
        var organisations = response.filter(
          (organisation) => organisation.hideRecord !== true || (this.settings && this.settings.organisationId && organisation.id === this.settings.organisationId)
        );

        if (this.userService.hasPriv('multiorgadmin')) {
          var userOrgs = this.userService.getCurrentUser()?.userOrganisations;
          if (environment.limitAccessToSubjectsByOrg && userOrgs && userOrgs.length > 0 && this.userService.getCurrentUser()) {
            organisations = organisations.filter(i => userOrgs.findIndex(j => j.organisationId == i.id) > -1);
          }
        }
        else if (environment.limitAccessToSubjectsByOrg && this.userService.getCurrentUser().role.toLocaleLowerCase() !='admin') {
          organisations = organisations.filter(i => i.id == this.userService.getCurrentUser()?.organisationId);
        }

        if (organisations.length > 1) {
          organisations.sort((a, b) => a.name.localeCompare(b.name));
          organisations = organisations.filter(i=>{ return (i.id!=-1)});
          organisations.unshift({ id: -1, name: 'All' });
        }
        this.organisations = organisations;
      }
    });

    this.showOrganisations = this.organisationService.showOrganisations;
    if (this.showOrganisations) {
      this.organisationService.getAll();
      if (this.settings.typeId) {
        const subjectType = this.types.find((i) => i.id === this.settings.typeId);
        if (subjectType) {
          this.hasOrganisation = this.organisationService.hasOrganisation(subjectType);
          this.organisationLabel = this.organisationService.organisationLabel(subjectType.name);
        }
      }
      else {
        this.organisationLabel = this.organisationService.organisationLabel();
      }
    }

    this.onTypesChanged = this.subjectTypeService.onChanged.subscribe((response) => {
      if (response.length > 0) {
        const types = response.filter((type) => ((type.hideRecord !== true) ||
          (this.settings && ((type.id === this.settings.typeId) || (type.id === this.settings.extraTypeId)))));

        // MRD - see #9513.  Logically we shouldn't assign status to non primary subject,
        // but it appears we currently can, so don't filter here so we are at least consistent
        // if (this.settings.showFlags === 2) {
        //   types = types.filter((i) => i.primary);
        // }

        types.sort((a, b) => a.name.localeCompare(b.name));
        this.types = types;

        // This code is required here to restore organisation selection when loading.
        this.showOrganisations = this.organisationService.showOrganisations;
        if (this.showOrganisations) {
          const subjectType = this.types.find((i) => i.id === this.settings.typeId);
          if (subjectType) {
            this.hasOrganisation = this.organisationService.hasOrganisation(subjectType);
            this.organisationLabel = this.organisationService.organisationLabel(subjectType.name);
          }
        }
      }
    });

    this.subjectTypeService.getAll();


    this.form = this.fb.group({
      caseOrReferralDueReview: [true],
      referralCounts: [(this.settings.typeId == 2 ? true : false)],
      showExtra: [false],
      context: [this.prevContextValue, Validators.required],
      typeId: [this.settings.typeId],
      organisationId: [this.settings.organisationId || -1, Validators.required],
      filterId: [this.settings.filterId],
      label: [this.settings.label || 'Due Review'],
      title: [this.settings.title || 'Due Review'],
    });

    this.color = this.settings.color;
    this.originalColor = this.settings.color;

    this.patchTitleAndLabels(this.settings);

    
    Utilities.patchCheckboxAria(); //see if this does anything??
  }

  ngOnDestroy() {
    if (this.onTypesChanged) {
      this.onTypesChanged.unsubscribe();
    }
    if (this.activeUsers) {
      this.activeUsers.unsubscribe();
    }
    this.onOrganisationsChanged?.unsubscribe();
  }
  contextChange(ev: MatSelectChange) {
    const val = ev.value;
    if (val && Array.isArray(val)) {
      const newValues =
        this.prevContextValue && this.prevContextValue.length > 0
          ? val.filter((i) => !this.prevContextValue.includes(i))
          : val;
      const cValues = newValues.filter((i) => i < 1);
      const patchValue =
        cValues.length > 0 ? [cValues[0]] : val.filter((i) => i > 0);
      this.form.controls.context.patchValue(patchValue);
      this.prevContextValue = patchValue;
    } else {
      this.prevContextValue = ev.value;
    }
    this.selectionChange(ev);
  }

  onColorChange(color) {
    if (color && this.originalColor !== color) {
      this.form.markAsDirty();
    }
  }

  markFilterAsChanged() {
    // this.titleChanged = true;

    const data: CountWidgetSettings = this.form.getRawValue();
    console.log(data, this.form);
    console.log(this.form)
    this.patchTitleAndLabels(data);
  }
  subjectTypeChange(ev: MatSelectChange) {
    const val = ev.value;    
    if (this.showOrganisations) {
      const subjectType = this.types.find((i) => i.id === val);
      if (subjectType) {
        this.hasOrganisation = this.organisationService.hasOrganisation(subjectType);
        this.organisationLabel = this.organisationService.organisationLabel(subjectType.name);
      }
    }

    this.selectionChange(ev);
  }

  selectionChange(ev: MatSelectChange) {
    var data: CountWidgetSettings = this.form.getRawValue();
    console.log(data, this.form)

    // this.titleChanged = true;

    if (data.typeId === 2) {
      this.form.controls['referralCounts'].setValue(true);
      data.referralCounts = true;
    }
    if (data.typeId === 1) {
      this.form.controls['referralCounts'].setValue(false);
      data.referralCounts = false;
    }
    this.patchTitleAndLabels(data);
  }

  patchTitleAndLabels(settings: CountWidgetSettings) {
    if (!this.labelChanged) {
      this.form.controls.label.patchValue(
        this.labelService.getDefaultCountLabel(settings).toUpperCase()
      );
      // this.labelChanged = false;
    }
    if (!this.titleChanged) {
      this.form.controls.title.patchValue(
        this.labelService.getReviewTitle(settings, undefined)
      );
      // this.titleChanged = false;
    }
  }

  markTitleAsChanged() {
    this.titleChanged = true;
  }

  markLabelAsChanged() {
    this.labelChanged = true;
  }

  save() {
    const data = this.form.getRawValue();
    /*
    
    if (data.label === this.labelService.getDefaultCountLabel(data)) {
      data.label = undefined;
    }
    if (data.title === this.labelService.getReviewTitle(data, undefined)) {
      data.title = undefined;
    }
    */

    if (!this.hasOrganisation) {
      data.organisationId = -1;
    }

    data.color = this.color;
    this.dialogRef.close({ data });
  }
}
